import React from 'react';
import { formatDateTime, isOverdue } from '../../../utils/dateUtils';

const PRIORITY_EMOJI = { urgent: '🔴', high: '🟠', medium: '🟡', low: '⚪' };

const STATUS_LABEL = {
  pending:       '⏳ Pending',
  'in-progress': '⚡ In Progress',
  completed:     '✅ Done',
};

const STATUS_ACTIONS = [
  { from: 'pending',     to: 'in-progress', label: '⚡ Start',    mod: 'progress' },
  { from: 'in-progress', to: 'completed',   label: '✅ Complete', mod: 'complete' },
  { from: 'completed',   to: 'pending',     label: '🔄 Reopen',  mod: 'reopen'   },
];

export default function TaskCard({ task, isAdmin, canAssign, onEdit, onDelete, onStatusChange }) {
  const overdue = isOverdue(task.dueDate, task.status);
  const action  = STATUS_ACTIONS.find(a => a.from === task.status);

  return (
    <div className={`task-card task-card--${task.priority}${task.status === 'completed' ? ' task-card--completed' : ''}`}>

      {/* Priority + status badges */}
      <div className="task-card__header">
        <div className="task-card__badges">
          <span className={`task-card__badge task-card__badge--${task.priority}`}>
            {PRIORITY_EMOJI[task.priority]} {task.priority}
          </span>
          <span className={`task-card__badge task-card__badge--${task.status}`}>
            {STATUS_LABEL[task.status]}
          </span>
        </div>
      </div>

      <h3 className="task-card__title">{task.title}</h3>

      {task.description && (
        <p className="task-card__desc">{task.description}</p>
      )}

      <span className="task-card__category">📁 {task.category}</span>

      {/* Meta info */}
      <div className="task-card__meta">
        {isAdmin && (
          <div className="task-card__meta-row">
            <span>👤</span>
            <span>Assigned to <strong>{task.assignedToName}</strong></span>
          </div>
        )}
        <div className="task-card__meta-row">
          <span>✍️</span>
          <span>By <strong>{task.createdByName}</strong></span>
        </div>
        {task.dueDate && (
          <div className={`task-card__meta-row${overdue ? ' task-card__overdue' : ''}`}>
            <span>📅</span>
            <span>
              {overdue ? '⚠️ Overdue: ' : 'Due: '}
              <strong>{formatDateTime(task.dueDate)}</strong>
            </span>
          </div>
        )}
        {task.completedAt && (
          <div className="task-card__meta-row">
            <span>✅</span>
            <span>Completed <strong>{formatDateTime(task.completedAt)}</strong></span>
          </div>
        )}
      </div>

      {task.notes && (
        <div className="task-card__notes">💬 {task.notes}</div>
      )}

      {/* Action buttons */}
      <div className="task-card__actions">
        {action && (
          <button
            className={`task-card__action-btn task-card__action-btn--${action.mod}`}
            onClick={() => onStatusChange(task.id, action.to)}
          >
            {action.label}
          </button>
        )}
        {canAssign && (
          <>
            <button
              className="task-card__action-btn task-card__action-btn--edit"
              onClick={() => onEdit(task)}
              aria-label="Edit task"
            >
              ✏️
            </button>
            <button
              className="task-card__action-btn task-card__action-btn--delete"
              onClick={() => onDelete(task.id)}
              aria-label="Delete task"
            >
              🗑️
            </button>
          </>
        )}
      </div>
    </div>
  );
}
